const press = (() => {
  const pressToggles = ".js-pressToggle";

  function onToggleClick(e) {
    e.preventDefault();
    let toggles = document.querySelectorAll(pressToggles)

    toggles.forEach((el) => {
      if (el == e.currentTarget) {
        el.parentNode.classList.contains('active')
        ? el.parentNode.classList.remove('active')
        : el.parentNode.classList.add('active')
      }
    })
  }

  function bind() {

    const toggles = document.querySelectorAll(pressToggles);
      Array.prototype.forEach.call(toggles, (el) => {
        el.removeEventListener("click", onToggleClick);
        el.addEventListener("click", onToggleClick);
    });

  }

  function init() {
    bind();
  }

  return {
    init,
  };
})();

export default press;